import React, {useEffect, useRef, useState} from "react";
import Button from 'reactstrap/lib/Button';
import Col from 'reactstrap/lib/Col';
import CustomInput from 'reactstrap/lib/CustomInput';
import Form from 'reactstrap/lib/Form';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import Row from 'reactstrap/lib/Row';
import Swal from "sweetalert2";
import {Toast} from "../../../../utils/sweetAlert";
import {UsersSchema} from "../scheme";
import {useForm} from "react-hook-form";
import * as AXIOS from "../../../../services/usersService";
import {t, getLanguage} from "react-switch-lang";
import {BASE_URL} from "../../../../utils/const";
import SelectSearchMulti from "../../../../components/select/SelectSearchMulti";
import {yupResolver} from '@hookform/resolvers';
const EditUserForm = props => {
    const [login, setLogin] = useState(props.data.login);
    const [userExists, setUserExists] = useState(false);
    const [email, setEmail] = useState(props.data.email);
    const [emailExists, setEmailExists] = useState(false);
    const [langKey, setLangKey] = useState(props.data.langKey);
    const [authorities, setRoles] = useState([]);
    const [rolesSend, setRolesSend] = useState([]);
    const [rolesError, setRolesError] = useState(false);
const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  


    const loginFocus = useRef();
    const emailFocus = useRef();
    const roleFocus = useRef(null);
  

    const {register, handleSubmit, setValue, watch, errors} = useForm({
        defaultValues: {
            firstName: props.data.firstName,
            lastName: props.data.lastName,
            authorities: props.data.authorities,
           
        },
        resolver: yupResolver(UsersSchema),
    });

    

    const putUsers = async formData => {
        await AXIOS.updateUser(formData)
        .then((r) => {
            Toast.fire({
              icon: 'success',
              title: `${t('message.successEdit')}`,
            });
            props.setRowChanged();
            props.toggleModal();
            setIsButtonDisabled(false);
          })
            .catch(r => {
                if ( r.response.data.errorKey === "userexists") {
                    setUserExists(true);
                    setIsButtonDisabled(false);
                    loginFocus.current.focus();
                } else if ( r.response.data.errorKey === "emailexists") {
                    setEmailExists(true);
                    setIsButtonDisabled(false);
                    emailFocus.current.focus();
                } else {
                    Swal.fire({
                        text: `${t("message.errorApi")}`,
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                    setIsButtonDisabled(false);
                }
            });
        setIsButtonDisabled(false);
    };

    const submitForm = () => {
       authorities !== null && authorities.length === 0 && setRolesError(true);

        if (authorities.length > 0) {
            setIsButtonDisabled(true);

            const formEdit = {
                id: props.data.id,
                login: watch("login"),
                firstName: watch("firstName"),
                lastName: watch("lastName"),
                email: watch("email"),
                authorities: rolesSend,
                activated: props.data.activated,
                langKey: langKey
            };
            putUsers(formEdit);
            // setIsButtonDisabled(false);
        }
    };

    const checkDropdownRoles = (e) => {
        setRoles(e);
        setRolesError(false);
        if(e === null ){
            setValue("authorities", [])
        }
        if (e !== null && e.length > 0) {
            errors.authorities = undefined;

            const data = [];
            e.map(item => {
                data.push(item.value)
            });
            setRolesSend(data);
            setValue("authorities", data)
        } else {
            errors.authorities = {
                message: `${t("message.fieldRequired")}`,
                type: "required"
            };
            if (errors.authorities) {
                const focusRole = roleFocus.current.select;
                focusRole.focus()
            }
        }
    };

   

    const handleRadioButtonChange = e => {
        setLangKey(e.target.value);
    };

    const getRoles = async () => {
        await AXIOS.getRoles(props.data.authorities, setRoles);
        setRolesSend(props.data.authorities)
    };
   

    useEffect(() => {
        getRoles();
       
    }, []);

    useEffect(() => {
        register({name: "authorities", type: 'custom'}, {required: true});
        
    }, [register]);


    const handleCancel = e => {
        e.preventDefault();
        props.toggleModal();
    };
  

    return (
        <Form onSubmit={handleSubmit(submitForm)}>
            <FormGroup className="mb-0">
            <Row className="mb-4">
                    <Col sm={12}>
                        <Label
                            for="firstNameEdit">{t("users.label.firstname")}</Label>
                        <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            className={
                                "form-control " +
                                (errors.firstName !== undefined ? "error-field" : "")
                            }
                            placeholder={t('placeholder.firstName')}
                            ref={register}
                        />
                        {errors.firstName && (
                            <span
                                className="error-message">{errors.firstName.message}</span>
                        )}
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col sm={12}>
                        <Label
                            for="lastNameEdit">{t("users.label.lastname")}</Label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            className={
                                "form-control " +
                                (errors.lastName !== undefined ? "error-field" : "")
                            }
                            placeholder={`${t("placeholder.lastName")}`}
                            ref={register}
                        />
                        {errors.lastName && (
                            <span
                                className="error-message">{errors.lastName.message}</span>
                        )}
                    </Col>
                </Row>
              
                <Row className="mb-4">
                    <Col sm={12}>
                        <Label for="login">{t("users.label.username")}</Label>
                        <input
                            type="text"
                            id="login"
                            name="login"
                            className={
                                "form-control " +
                                (errors.login !== undefined || userExists ? "error-field" : "")
                            }
                            value={login}
                            placeholder={` ${t("placeholder.username")}`}
                            onChange={e => {
                                setLogin(e.target.value);
                                setUserExists(false);
                            }}
                            ref={e => {
                                register(e);
                                loginFocus.current = e;
                            }}
                            
                        />
                        {errors.login && (
                            <span
                                className="error-message">{errors.login.message}</span>
                        )}
                        {userExists && (
                            <span className="error-message">
                {t("message.errorUsername")}
              </span>
                        )}
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col sm={12}>
                        <Label for="emailEdit">{t("users.label.email")}</Label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            className={
                                "form-control " +
                                (errors.email !== undefined || emailExists ? "error-field" : "")
                            }
                            placeholder={`${t("placeholder.email")}`}
                            onChange={e => {
                                setEmail(e.target.value);
                                setEmailExists(false);
                            }}
                            ref={e => {
                                register(e);
                                emailFocus.current = e;
                            }}
                            
                        />
                        {errors.email && (
                            <span
                                className="error-message">{errors.email.message}</span>
                        )}
                        {emailExists && (
                            <span
                                className="error-message">{t("message.errorEmail")}</span>
                        )}
                    </Col>
                </Row>
                <Row className="search mb-4">
                    <Col sm={12}>
                        <Label
                            for="rolesEdit">{t("users.label.authorities")}</Label>

                        <SelectSearchMulti
                            api={`${BASE_URL}/authorities?sort.sorted=true`}
                            name="authorities"
                            className={errors.authorities && "error-field"}
                            placeholder={`${t('placeholder.role')}`}
                            value={authorities}
                            isMulti={true}
                            onChange={checkDropdownRoles}
                            ref={roleFocus}
                            optionValue="name"
                            optionLabel={getLanguage() === "eng" ? "name" : "description"}
                            isSearchable={false}
                        />
                        {errors.authorities && (
                            <span className="error-message">
                  {errors.authorities.message}
              </span>
                        )}
                    </Col>
                </Row>
            
                <Row className="mb-4">
                    <Col sm={12}>
                        <Label
                            for="language">{t("users.label.language")}</Label>
                        <CustomInput
                            className="administration-modal-radio"
                            value="mne"
                            type="radio"
                            name="lang-group"
                            checked={langKey ===  "mne"}
                            id="language2"
                            label={t("lang.montenegrin")}
                            onChange={e => handleRadioButtonChange(e)}
                        />
         
                        <CustomInput
                            className="administration-modal-radio"
                            value="eng"
                            type="radio"
                            name="lang-group"
                            checked={langKey === "eng"}
                            id="language"
                            label={t("lang.english")}
                            onChange={e => handleRadioButtonChange(e)}
                        />
                    </Col>
                </Row>
          
                <Row className="submit-buttons-container mx-0">
                    <Col sm={12} className="text-right px-0">
                        <div className="submit">
                            <Button
                                className="primary cancel"
                                disabled={isButtonDisabled}
                                onClick={e => handleCancel(e)}
                                type="reset"
                            >
                                {t("buttons.cancelBtn")}
                            </Button>
                            <Button className="primary"
                                    disabled={isButtonDisabled}>
                                {t("buttons.saveBtn")}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </FormGroup>
        </Form>
    );
};

export default EditUserForm;
